module.exports = __webpack_public_path__ + "static/img/logo4.2f8cc3b2.png";